
import "../globals/global.css"
import "./revivaljourney.css"
import PageTitle from '../../../components/Page Title/PageTitle';
import NavigationBar from '../../../components/navbar/NavigationBar'

import launcher_2013 from '../../../assets/photos/journey/2013/Screenshot_21.webp'
import gameplay_2013 from '../../../assets/photos/journey/2013/journey-2013_2.webp'
import launcher_2014 from '../../../assets/photos/journey/2014/launcher2014.webp'
import gameplay_2016 from '../../../assets/photos/journey/2016/journey-2016.webp'

import launcher_2017 from '../../../assets/photos/journey/2017/launcher_1.webp'
import launcher_2017_2 from '../../../assets/photos/journey/2017/launcher_2.webp'
import gameplay_2017 from '../../../assets/photos/journey/2017/gameplay_2017.webp'

import launcher_2023 from '../../../assets/photos/journey/2023/eac.webp'
import launcher_2023_2 from '../../../assets/photos/journey/2023/launcher_3.webp'
import launcher_2023_3 from '../../../assets/photos/journey/2023/rts.webp'
import launcher_2023_4 from '../../../assets/photos/journey/2023/rts_2.webp'
import gameplay_2023 from '../../../assets/photos/journey/2023/gameplay.webp'

function ArrowSeparator({ variant = "default" }) {
  return (
            <div className="arrow-down">
              <div className="arrow-bottom-container ">
                <div className="arrow-bottom-r"></div>
                <div className="arrow-bottom-l"></div>
              </div>

              <div className="arrow-skip-container">
                <div className="arrow-end"></div>
                <div className="arrow-end"></div>
                <div className="arrow-end-mid"></div>
                <div className="arrow-end"></div>
                <div className="arrow-end"></div>

                <div className="arrow-end"></div>
                <div className="arrow-end"></div>
                <div className="arrow-end-mid"></div>
                <div className="arrow-end"></div>
                <div className="arrow-end"></div>

                <div className="arrow-end"></div>
                <div className="arrow-end"></div>
                <div className="arrow-end-mid"></div>
                <div className="arrow-end"></div>
                <div className="arrow-end"></div>
              </div>

              {variant === "default" && (
                <div className="arrow-top-container">
                  <div className="arrow-top-r second-stage-top"></div>
                  <div className="arrow-top-l second-stage-top"></div>
                </div>
              )}
            </div>
  );
}

const segment_2013_top = 50;
const segment_2014_top = 1400;
const segment_2016_top = 2225;
const segment_2017_top = 3100;
const segment_2023_top = 4600;
const segment_2026_top = 6400;



const RevivalJourney = () => {
  return (
    <div>
      <NavigationBar />
      <meta name="description" content="Everything about the progress of the Heroes & Generals revival project."></meta>
      <PageTitle title="Project History"/>
      <div className="pagebox pagebox-journey">
        <section className="date-marker" style={{marginTop: '1rem'}}>
          <label>Game closure -  May 2023</label>
        </section>
        <div className="timeline-container">
          <div className="arrow-down">
            <div className="arrow-top-container">
              <div className="arrow-top-r first-stage-top"></div>
              <div className="arrow-top-l first-stage-top"></div>
            </div>
          </div>
          <section className="date-marker">
            <label>HnG 2013</label>
          </section>
          <div className="arrow arrow-core" style={{height: '900px'}}></div>
          <section className="timeline-item left" style={{top: segment_2013_top+100}}>
            <div className="title">2013 Revival</div>
            <div className="date">12.2024</div>
            <span>The group responsible for the very first revival managed to combine information from a hacked client with a very old and buggy beta version, allowing people to feel the oldest nostalgia of HnG.</span>
            <ul>
              <li className="progress"><span className="icon">✔️</span>Foot Infantry and Aircraft Gameplay</li>
              <li className="info"><span className="icon">⚠️</span>Very buggy</li>
              <li className="info"><span className="icon">⚠️</span>Predefined loadouts</li>
            </ul>
          </section>
          <section className="timeline-item right image-container" style={{top: segment_2013_top+150}}>
            <img src={launcher_2013} className="imagebox" alt="2013 launcher" />
          </section>
          <section className="timeline-item right image-container" style={{top: segment_2013_top+600}}>
            <img src={gameplay_2013} className="imagebox" alt="2013 gameplay" />
          </section>

          <ArrowSeparator />
          <section className="date-marker">
            <label>HnG 2014</label>
          </section>
          <div className="arrow arrow-core" style={{height: '500px'}}>
          </div>
          <section className="timeline-item right" style={{top: segment_2014_top}}>
            <div className="title">2014 Revival</div>
            <div className="date">02.2025</div>
            <span>The 2014 group has later on managed to get a more stable beta version running. Quaseda 2014. It still had many missing features but it wasn't suffering the bugs present in the 2013 version.</span>
            <ul>
              <li className="progress"><span className="icon">✔️</span>Playable base game</li>
              <li className="progress"><span className="icon">✔️</span>Match templates</li>
              <li className="info"><span className="icon">⚠️</span>Default loadouts</li>
            </ul>
          </section>
          <section className="timeline-item left image-container" style={{top: segment_2014_top+100}}>
            <img src={launcher_2014} className="imagebox" alt="2014 launcher" />
          </section>



          <ArrowSeparator />
          <section className="date-marker">
            <label>HnG 2016</label>
          </section>
          <div className="arrow arrow-core" style={{height: '450px'}}></div>
          <section className="timeline-item left" style={{top: segment_2016_top}}>
            <div className="title">2016 Revival</div>
            <div className="date">04.2025</div>
            <span>Steamdepot discoveries led to finding a playable build of 2016, it reached a semi playable state but was abandoned eventually because of cheat commands being available.</span>
            <ul>
              <li className="progress"><span className="icon">✔️</span>Loadouts</li>
              <li className="progress"><span className="icon">✔️</span>A lot more playable game</li>
              <li className="progress"><span className="icon">✔️</span>Possible loadouts</li>
              <li className="info"><span className="icon">⚠️</span>Never finished</li>
            </ul>
          </section>
          <section className="timeline-item right image-container" style={{top: segment_2016_top+150}}>
            <img src={gameplay_2016} className="imagebox" alt="2016 gameplay" />
          </section>

          <ArrowSeparator />
          <section className="date-marker">
            <label>HnG 2017</label>
          </section>
          <div className="arrow arrow-core" style={{height: '1150px'}}></div>
          <section className="timeline-item right" style={{top: segment_2017_top}}>
            <div className="title">2017 Revival</div>
            <div className="date">29.05.2025</div>
            <span>Combining information from 2014, 2016 & 2023 work and a lucky find of a 2017 version allowed to get a fully stable and playable build.</span>
            <ul>
              <li className="progress"><span className="icon">✔️</span>Accounts with loadout customization</li>
              <li className="progress"><span className="icon">✔️</span>Map templates</li>
              <li className="progress"><span className="icon">✔️</span>Matchmaking</li>
              <li className="info"><span className="icon">⚠️</span>Work was discontinued</li>
            </ul>
          </section>

          <section className="timeline-item left image-container" style={{top: segment_2017_top+100}}>
            <img src={gameplay_2017} className="imagebox" alt="2017 gameplay" />
          </section>
          <section className="timeline-item left image-container" style={{top: segment_2017_top+550}}>
            <img src={launcher_2017_2} className="imagebox" alt="2017 launcher" />
          </section>
          <section className="timeline-item right image-container" style={{top: segment_2017_top+550}}>
            <img src={launcher_2017} className="imagebox" alt="2017 launcher" />
          </section>

          <ArrowSeparator />
          <section className="date-marker">
            <label>HnG 2023</label>
          </section>
          <div className="arrow arrow-core" style={{height: '1450px'}}></div>

          <section className="timeline-item left" style={{top: segment_2023_top}}>
            <div className="title">2023 Revival</div>
            <div className="date">2024-2026</div>
            <span>The full 2023 experience, just like how everyone remembers it.</span>
            <ul>
              <li className="progress"><span className="icon">✔️</span>Reverse Engineered</li>
              <li className="progress"><span className="icon">✔️</span>Original Working Flash Client</li>
              <li className="progress"><span className="icon">✔️</span>Working RTS</li>
              <li className="progress"><span className="icon">✔️</span>Account progression</li>
            </ul>
          </section>

          <section className="timeline-item right image-container" style={{top: segment_2023_top+100}}>
            <img src={launcher_2023} className="imagebox" alt="2023 gameplay" />
          </section>
          <section className="timeline-item right image-container" style={{top: segment_2023_top+500}}>
            <img src={gameplay_2023} className="imagebox" alt="2023 journey" />
          </section>
          <section className="timeline-item left image-container" style={{top: segment_2023_top+500}}>
            <img src={launcher_2023_2} className="imagebox" alt="2023 journey" />
          </section>
          <section className="timeline-item left image-container" style={{top: segment_2023_top+900}}>
            <img src={launcher_2023_3} className="imagebox" alt="2023 launcher" />
          </section>
          <section className="timeline-item right image-container" style={{top: segment_2023_top+900}}>
            <img src={launcher_2023_4} className="imagebox" alt="2023 launcher" />
          </section>



          <ArrowSeparator/>
          <section className="date-marker">
            <label>HnG 2026</label>
          </section>
          <div className="arrow arrow-core" style={{height: '750px'}}></div>
          <section className="timeline-item right" style={{top: segment_2026_top}}>
            <div className="title">2026 Testing</div>
            <div className="date">26.06.2025-current</div>
            <span>The limited testing of the game, nailing out the remaining bugs</span>
            <ul>
              <li className="progress"><span className="icon">✔️</span>Grind testing</li>
              <li className="progress"><span className="icon">✔️</span>Stress testing and finding suitable servers</li>
              <li className="progress"><span className="icon">✔️</span>Updated to 60 tickrate</li>
              <li className="progress"><span className="icon">✔️</span>Changed BE to EAC</li>
              <li className="progress"><span className="icon">✔️</span>RTS & FPS map editor</li>
              <li className="wip"><span className="icon"></span>Preparing infastructure for the playerbase</li>
              <li className="wip"><span className="icon"></span>Breaking the game</li>
              <li className="wip"><span className="icon">⚠️</span>Getting rid of bugs and exploits</li>
              <li className="info"><span className="icon">⚠️</span>Not launchable from steam (for now?)</li>
            </ul>
          </section>
          <section className="date-marker">
            <label>We are here</label>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RevivalJourney;


